import React, { useCallback, useState } from "react";

import { resumeCategories, texteDernierBuild } from "./filtresMap";

// Bulle d'information flottante (suit le curseur) partagee par les vues de la map.
// Usage : const { bulle, montrer, cacher } = useBulle(); <BulleFlottante bulle={bulle} />
export function useBulle() {
  const [bulle, setBulle] = useState(null);
  const montrer = useCallback((ev, contenu) => {
    const largeur = typeof window !== "undefined" ? window.innerWidth : 1200;
    setBulle({
      x: Math.min(ev.clientX + 14, largeur - 330),
      y: ev.clientY + 14,
      contenu,
    });
  }, []);
  const cacher = useCallback(() => setBulle(null), []);
  return { bulle, montrer, cacher };
}

export function BulleFlottante({ bulle }) {
  if (!bulle) return null;
  return (
    <div className="map-bulle" role="tooltip" style={{ left: bulle.x, top: bulle.y }}>
      {bulle.contenu}
    </div>
  );
}

// Contenu standard d'une bulle d'environnement : groupe, serveur, traitements par categorie.
export function ContenuBulleEnv({ env }) {
  return (
    <div>
      <b>
        {env.group} · {env.env}
      </b>
      <br />
      <span style={{ opacity: 0.75 }}>
        {env.server}
        {env.vague ? ` · ${env.vague}` : ""}
      </span>
      {env.nonRemonte ? (
        <div>
          Non remonté — Aucun build depuis 24 h ({texteDernierBuild(env.dernierBuild)})
        </div>
      ) : env.sans ? (
        <div>Sans traitement</div>
      ) : (
        resumeCategories(env).map(({ categorie, jobs, erreurs }) => (
          <div key={categorie}>
            {categorie} : {jobs}
            {erreurs ? <span className="map-bulle-err"> · {erreurs} en erreur</span> : null}
          </div>
        ))
      )}
    </div>
  );
}
